const route = {
  path: '/imageAndText/:id',
  name: 'imageAndText',
  component: () => import('@/views/imageAndText/index'),
  meta: { routeName: '图文', unGetUser: true }
}
export default route
